import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/header/Header";
import AboutUs from "./views/primaryPages/aboutUs/AboutUs";
import Support from './views/templates/support/Support'
import Home from "./views/primaryPages/home/Home";
import './app.css' ;
import Footer from './components/footer/Footer';
const App = () => {
  return (
    <BrowserRouter>
    <div style = {{marginBottom: '6rem'}}>
      <Header />  
      </div>
      <Routes>
        <Route>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/Support" element={<Support />} />
          {/* <Route path="/*" element={<ErrorPage />} /> */}
        </Route>
      </Routes>
      <Footer />
    </BrowserRouter>
  );
};

export default App;
